module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "ptb-100",
    attrs: {
      "id": "about"
    }
  }, [(_vm.content) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "800px"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading",
    staticStyle: {
      "color": "#409EFF",
      "font-size": "80px",
      "position": "relative",
      "left": "40%"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eccf08c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Menu.vue
// module id = 718
// module chunks = 1